export default __webpack_public_path__ + "static/media/payments.e66b598f.jpg";